import { PersonDisciplinaerstatus } from "../../../../../interfaces/schema";
import { stringDateToPP } from "../../../../../util/date";

export default function AktualStatusCard(props: {
  status: PersonDisciplinaerstatus | undefined;
  title: string;
}) {
  const { status, title } = props;

  return (
    <div className="c-card">
      <h3 className="mb-3 mt-2">{title}</h3>
      <div className="c-item-list">
        <div>
          <h5 className="form-label">Status</h5>
          <div className="form-control--value">
            {status ? status?.disciplinaerstatustypeNrNavigation?.navn : "-"}
          </div>
        </div>
        <div>
          <h5 className="form-label">Startdato</h5>
          <div className="form-control--value">
            {status ? stringDateToPP(status.periode.fraDato) : "-"}
          </div>
        </div>
        <div>
          <h5 className="form-label">Sagsnr. F2</h5>
          <div className="form-control--value">
            {status ? status.esdhSagsNr : "-"}
          </div>
        </div>
        <div>
          <h5 className="form-label">Bemærkning</h5>
          <div className="form-control--value">
            {" "}
            {status && status.bemaerkning ? status.bemaerkning : "-"}
          </div>
        </div>
      </div>
    </div>
  );
}
